export function getNumberOfDigitsAfterTheDecimal(value: number): number {
  return (
    Number(value.toPrecision(15))
      .toString()
      .match(/\d+\.(\d+)/)?.[1] ?? ""
  ).length;
}
